<template>
    <v-menu
        close-on-content-click
        offset-y
        left
        nudge-bottom="8"
        transition="scale-transition"
        origin="top right"
        attach="#language-menu"
    >
        <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip left>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        :aria-label="$t('AppHeader.language')"
                        small
                        text
                        v-bind="attrs"
                        color="genes-blue base"
                        class="text-subtitle-1 font-weight-medium"
                        data-cy="language"
                        v-on="{ ...menu, ...tooltip }"
                    >
                        <img
                            class="mr-1 language-icon"
                            :src="currentLanguageIcon"
                            alt=""
                            width="24"
                        />
                        <span>{{ $i18n.locale }}</span>
                    </v-btn>
                </template>
                <div>
                    {{ $t('AppHeader.languageTooltip') }}
                </div>
            </v-tooltip>
        </template>
        <v-list>
            <v-list-item
                v-for="(item, index) in locales"
                :key="`locale-${index}`"
                @click="onMenuClick(item)"
            >
                <v-list-item-icon class="mb-0 mr-3">
                    <img
                        :src="item.icon"
                        :alt="item.name"
                        width="24"
                        class="language-icon"
                    />
                </v-list-item-icon>
                <v-list-item-title
                    :class="{
                        'accent--text font-weight-medium':
                            $i18n.locale === item.code
                    }"
                >
                    <span>{{ item.name }}</span>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import Locales from '@/language/locales';
import { mapMutations } from 'vuex';

export default {
    name: 'LanguageSelect',
    data() {
        return {
            showMenu: false,
            assetPath: '/img/flags/'
        };
    },
    computed: {
        locales() {
            return Locales.filter(item => item.available).map(item => {
                return {
                    ...item,
                    icon: `${this.assetPath}${item.code}.svg`
                };
            });
        },
        currentLanguageIcon() {
            return `${this.assetPath}${this.$i18n.locale}.svg`;
        }
    },
    methods: {
        ...mapMutations(['setLanguage']),
        onMenuClick(item) {
            if (item.code !== this.$i18n.locale) {
                this.$i18n.locale = item.code;
                this.$vuetify.lang.current = item.code;
                this.setLanguage(item.code);
                this.$store.dispatch('notifier/success', {
                    message: this.$t('AppHeader.languageSwitchedMessage', [
                        item.code.toUpperCase()
                    ])
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.language-icon {
    border: solid thin map-get($deep-grey, 'darken-1');
}
</style>
